module.exports = __webpack_public_path__ + "img/2020_12_13_goat_teeth_snake.62bf3f5b.jpg";